/*---------------------------------------------------------------------------------------------
* Copyright (c) Bentley Systems, Incorporated. All rights reserved.
* Licensed under the MIT License. See LICENSE.md in the project root for license terms.
*--------------------------------------------------------------------------------------------*/

export class DoublyLinkedNode<T> {
  /** The value of the node */
  public value: T;
  /** The previous node reference */
  public prev?: DoublyLinkedNode<T>;
  /** The next node reference */
  public next?: DoublyLinkedNode<T>;

  public constructor(value: T) {
    this.value = value;
  }
}